// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { DashboardChapakComponent } from './dashboard-chapak.component';

@NgModule({
    imports: [

    ],
    declarations: [
        DashboardChapakComponent,
    ],
    exports: [
        DashboardChapakComponent,
    ]
})
export class DashboardChapakModule {

}
